import requestAction from '../../utils/requestAction'

export const fetchDeliveryAreas = (params: string) =>
  requestAction('DELIVERY_AREA_LIST', params)(`deliveryAreas`, 'GET')
